"use client"

import { useEffect, useState } from "react"
import { useSettingsStore } from "@/lib/settings-store"
import { useMediaQuery } from "@/hooks/use-mobile"

export function useResponsiveGridColumns() {
  const { gridColumns, setGridColumns } = useSettingsStore()
  const [mounted, setMounted] = useState(false)

  const isMobile = useMediaQuery("(max-width: 640px)")
  const isTablet = useMediaQuery("(max-width: 1024px) and (min-width: 641px)")

  useEffect(() => {
    if (!mounted) {
      setMounted(true)
      return
    }

    const hasSetResponsiveDefault = localStorage.getItem("responsive-grid-set")

    if (hasSetResponsiveDefault) return // Already set responsive defaults before

    console.log("[v0] Setting responsive grid defaults", { isMobile, isTablet, gridColumns })

    // Default for every screen size is 3 columns (owner decision 2026-10-24). Only browsers that have not picked one yet get this;
    // anyone who chose their own count, or Auto, keeps it.
    setGridColumns(3)

    // Mark that we've set the responsive default
    localStorage.setItem("responsive-grid-set", "true")
  }, [mounted, isMobile, isTablet, setGridColumns])

  return {
    gridColumns,
    setGridColumns,
    isMobile,
    isTablet,
  }
}
